// 路由配置
/**
 * 规则：
 * 一、例如：index/index，shop/index以index结尾的，path和name默认去除index
 * 二、例如：shop/list，默认生成name为shop_list（如果结尾为index，例如shop/index则是shop）
 * 三、填写后不会自动生成
 * **/
let routes = [{
		path: '/',
		name: 'layout',
		redirect: {name: 'index'},
		component: 'layout',
		// 注册路由 添加新页面
		children: [
			{
				meta:{title:'后台首页'},
				component:'index/index'
			},
			{
				meta:{title:'系统公告'},
				component:'xtgl/xtxx/xtgg/index'
			},
			{
				meta:{title:'个人资料'},
				component:'xtgl/xtxx/grzl/index'
			},
			{
				meta:{title:'企业配置'},
				component:'xtgl/xtxx/qypz/index'
			},
			{
				meta:{title:'员工管理'},
				component:'set/manager/index'
			},
			{
				meta:{title:'部门机构'},
				component:'xtgl/jsry/bmjg/index'
			},
			{
				meta:{title:'操作日志'},
				component:'xtgl/jsry/czrj/index'
			},
			{
				meta:{title:'下载限制'},
				component:'xtgl/jsry/xzxz/index'
			},
			{
				meta:{title:'上班设置'},
				component:'xtgl/jsry/sbsz/index'
			},
			{
				meta:{title:'可视化大屏数据面板'},
				component:'xtgl/qtgn/app/index'
			},
			{
				meta:{title:'企业微信'},
				component:'xtgl/qtgn/qywx/index'
			},
			{
				meta:{title:'打印模板管理'},
				component:'xtgl/qtgn/dymb/index'
			},
			{
				meta:{title:'索引表'},
				component:'xtgl/qtgn/syb/index'
			},
			{
				meta:{title:'批次号'},
				component:'xtgl/qtgn/pch/index'
			},
			{
				meta:{title:'电子秤'},
				component:'jjfa/sbdj/dzc/index'
			},
			{
				meta:{title:'打印机'},
				component:'jjfa/sbdj/dyj/index'
			},
			{
				meta:{title:'资产负债表'},
				component:'cwbb/zcfz/zcfzb/index'
			},
			{
				meta:{title:'账户余额表'},
				component:'cwbb/zcfz/zhyeb/index'
			},
			{
				meta:{title:'应收账龄表'},
				component:'cwbb/zcfz/yszlb/index'
			},
			{
				meta:{title:'应付账龄表'},
				component:'cwbb/zcfz/yfzlb/index'
			},
			{
				meta:{title:'利润表'},
				component:'cwbb/szlr/lrb/index'
			},
			{
				meta:{title:'现金流量表'},
				component:'cwbb/szlr/xjllb/index'
			},
			{
				meta:{title:'项目收支表'},
				component:'cwbb/szlr/xmszb/index'
			},
			{
				meta:{title:'部门收支表'},
				component:'cwbb/szlr/bmszb/index'
			},
			{
				meta:{title:'职员收支表'},
				component:'cwbb/szlr/zyszb/index'
			},
			{
				meta:{title:'客户收支表'},
				component:'cwbb/szlr/khszb/index'
			},
			{
				meta:{title:'供应商收支表'},
				component:'cwbb/szlr/gysszb/index'
			},
			{
				meta:{title:'财务明细'},
				component:'cwgl/cwxx/cwmx/index'
			},
			{
				meta:{title:'明细统计'},
				component:'cwgl/cwxx/mxtj/index'
			},
			{
				meta:{title:'收款订单'},
				component:'cwgl/srjz/skdd/index'
			},
			{
				meta:{title:'预收款订单'},
				component:'cwgl/srjz/yskdd/index'
			},
			{
				meta:{title:'收回欠款'},
				component:'cwgl/srjz/shqk/index'
			},
			{
				meta:{title:'退还收入'},
				component:'cwgl/srjz/thsr/index'
			},
			{
				meta:{title:'借入/收押金等'},
				component:'cwgl/srjz/jr/index'
			},
			{
				meta:{title:'转账取存'},
				component:'cwgl/srjz/zzqc/index'
			},
			
			{
				meta:{title:'收款订单添加'},
				component:'cwgl/srjz/skdd/create'
			},
			{
				meta:{title:'预收款订单添加'},
				component:'cwgl/srjz/yskdd/create'
			},
			{
				meta:{title:'收回欠款添加'},
				component:'cwgl/srjz/shqk/create'
			},
			{
				meta:{title:'退还收入添加'},
				component:'cwgl/srjz/thsr/create'
			},
			{
				meta:{title:'借入/收押金等添加'},
				component:'cwgl/srjz/jr/create'
			},
			{
				meta:{title:'转账取存添加'},
				component:'cwgl/srjz/zzqc/create'
			},
			{
				meta:{title:'付款订单'},
				component:'cwgl/zcjz/fkdd/index'
			},
			{
				meta:{title:'预付款订单'},
				component:'cwgl/zcjz/yfkdd/index'
			},
			{
				meta:{title:'偿还欠款'},
				component:'cwgl/zcjz/chqk/index'
			},
			{
				meta:{title:'退还支出'},
				component:'cwgl/zcjz/thzc/index'
			},
			{
				meta:{title:'借出/交押金等'},
				component:'cwgl/zcjz/jc/index'
			},
			
			{
				meta:{title:'付款订单添加'},
				component:'cwgl/zcjz/fkdd/create'
			},
			{
				meta:{title:'预付款订单添加'},
				component:'cwgl/zcjz/yfkdd/create'
			},
			{
				meta:{title:'偿还欠款添加'},
				component:'cwgl/zcjz/chqk/create'
			},
			{
				meta:{title:'退还支出添加'},
				component:'cwgl/zcjz/thzc/create'
			},
			{
				meta:{title:'借出/交押金等添加'},
				component:'cwgl/zcjz/jc/create'
			},
			{
				meta:{title:'签收报表'},
				component:'kqgz/kqgz/qsbb/index'
			},
			{
				meta:{title:'库存报表'},
				component:'kqgz/kqgz/jbsz/index'
			},
			{
				meta:{title:'出入仓流水明细'},
				component:'kqgz/kqgz/jqbz/index'
			},
			{
				meta:{title:'欠款报表'},
				component:'kqgz/kqgz/kqjl/index'
			},
			{
				meta:{title:'运费报表'},
				component:'kqgz/kqgz/gzb/index'
			},
			{
				meta:{title:'配送人员结算'},
				component:'kqgz/kqgz/gzb/mx'
			},
			{
				meta:{title:'工资流水'},
				component:'kqgz/kqgz/gzb/ls'
			},
			{
				meta:{title:'编辑工资名单'},
				component:'kqgz/kqgz/gzb/create'
			},
			{
				meta:{title:'财务计费'},
				component:'rwlc/rwlc/cjrw/index'
			},
			{
				meta:{title:'入仓处置费'},
				component:'rwlc/rwlc/dshrw/index'
			},
			{
				meta:{title:'出仓单对单'},
				component:'rwlc/rwlc/dbrw/index'
			},
			{
				meta:{title:'已完成任务'},
				component:'rwlc/rwlc/ywcrw/index'
			},
			{
				meta:{title:'任务列表'},
				component:'rwlc/rwlc/rwlb/index'
			},
			{
				meta:{title:'月统计报表'},
				component:'rwlc/szhtj/lcsz/index'
			},
			{
				meta:{title:'库存变动报表'},
				component:'rwlc/szhtj/lctj/index'
			},
			{
				meta:{title:'大客户返存统计表'},
				component:'rwlc/szhtj/rwtj/index'
			},
			{
				meta:{title:'代付订单'},
				component:'djgl/ddcl/dfdd/index'
			},
			{
				meta:{title:'编辑代付订单'},
				component:'djgl/ddcl/dfdd/create'
			},
			{
				meta:{title:'其他费用单'},
				component:'djgl/ddcl/qtfyd/index'
			},
			{
				meta:{title:'过车费单'},
				component:'djgl/ddcl/gcfd/index'
			},
			{
				meta:{title:'装卸工单'},
				component:'djgl/ddcl/zxgd/index'
			},
			{
				meta:{title:'理货工单'},
				component:'djgl/ddcl/lhgd/index'
			},
			{
				meta:{title:'分类工单'},
				component:'djgl/ddcl/flgd/index'
			},
			{
				meta:{title:'库存转单'},
				component:'djgl/ddcl/kczd/index'
			},
			{
				meta:{title:'编辑其他费用单'},
				component:'djgl/ddcl/qtfyd/create'
			},
			{
				meta:{title:'编辑过车费单'},
				component:'djgl/ddcl/gcfd/create'
			},
			{
				meta:{title:'编辑装卸工单'},
				component:'djgl/ddcl/zxgd/create'
			},
			{
				meta:{title:'编辑理货工单'},
				component:'djgl/ddcl/lhgd/create'
			},
			{
				meta:{title:'编辑分类工单'},
				component:'djgl/ddcl/flgd/create'
			},
			{
				meta:{title:'编辑库存转单'},
				component:'djgl/ddcl/kczd/create'
			},
			{
				meta:{title:'代付报表'},
				component:'djgl/sjbb/dfbb/index'
			},
			{
				meta:{title:'生产报工'},
				component:'djgl/gxhbg/scbg/index'
			},
			{
				meta:{title:'报工记录'},
				component:'djgl/gxhbg/bgjl/index'
			},
			{
				meta:{title:'生产提交'},
				component:'djgl/zjhrk/sctj/index'
			},
			{
				meta:{title:'生产质检'},
				component:'djgl/zjhrk/sczj/index'
			},
			{
				meta:{title:'成品入库'},
				component:'djgl/zjhrk/cprk/index'
			},
			{
				meta:{title:'BOM表'},
				component:'djgl/sczl/bom/index'
			},
			{
				meta:{title:'生产工序'},
				component:'djgl/sczl/scgx/index'
			},
			{
				meta:{title:'生产组'},
				component:'djgl/sczl/scz/index'
			},
			{
				meta:{title:'生产产品'},
				component:'djgl/sczl/sccp/index'
			},
			{
				meta:{title:'调拨单'},
				component:'ckgl/ckcl/dbd/index'
			},
			{
				meta:{title:'盘点单'},
				component:'ckgl/ckcl/pdd/index'
			},
			{
				meta:{title:'组装单'},
				component:'ckgl/ckcl/zzd/index'
			},
			{
				meta:{title:'拆卸单'},
				component:'ckgl/ckcl/cxd/index'
			},
			{
				meta:{title:'损耗单'},
				component:'ckgl/ckcl/shd/index'
			},
			{
				meta:{title:'仓库明细'},
				component:'ckgl/ckxx/ckmx/index'
			},
			{
				meta:{title:'库存流水'},
				component:'ckgl/ckxx/kcls/index'
			},
			{
				meta:{title:'库存预警'},
				component:'ckgl/ckxx/kcyj/index'
			},
			{
				meta:{title:'期初库存'},
				component:'ckgl/ckxx/qckc/index'
			},
			{
				meta:{title:'仓库产品统计'},
				component:'ckgl/cktj/ckcptj/index'
			},
			{
				meta:{title:'仓库分类统计'},
				component:'ckgl/cktj/ckfltj/index'
			},
			{
				meta:{title:'仓库类型统计'},
				component:'ckgl/cktj/cklxtj/index'
			},
			{
				meta:{title:'仓库库存统计'},
				component:'ckgl/cktj/ckkctj/index'
			},
			{
				meta:{title:'保质期分布'},
				component:'ckgl/cktj/bzqfb/index'
			},
			{
				meta:{title:'仓库流量统计'},
				component:'ckgl/cktj/cklltj/index'
			},
			{
				meta:{title:'单证中心'},
				component:'ccgl/ddcl/ccdd/index'
			},
			{
				meta:{title:'收发中心'},
				component:'ccgl/ddcl/ccdd/indexSFZX'
			},
			{
				meta:{title:'仓储中心'},
				component:'ccgl/ddcl/ccdd/indexCCZX'
			},
			{
				meta:{title:'出仓申请单'},
				component:'ccgl/ddcl/ccdd/ccsqd'
			},
			{
				meta:{title:'单证中心'},
				component:'rcgl/ddcl/rcdd/index'
			},
			{
				meta:{title:'收发中心'},
				component:'rcgl/ddcl/rcdd/indexSFZX'
			},
			{
				meta:{title:'仓储中心'},
				component:'rcgl/ddcl/rcdd/indexCCZX'
			},
			{
				meta:{title:'返存订单'},
				component:'rcgl/ddcl/fcdd/index'
			},
			{
				meta:{title:'平台订单'},
				component:'rcgl/ddcl/jhdd/index'
			},
			{
				meta:{title:'货物上板'},
				component:'rcgl/ddcl/hwsb/index'
			},
			{
				meta:{title:'货物转库'},
				component:'rcgl/ddcl/hwzk/index'
			},
			{
				meta:{title:'入仓装卸单'},
				component:'rcgl/ddcl/rczxd/index'
			},
			// {
			// 	meta:{title:'销售明细表'},
			// 	component:'xsgl/xsxx/xsmxb/index'
			// },
			{
				meta:{title:'客户信息'},
				component:'khgl/khgl/khxx/index'
			},
			{
				meta:{title:'公海设置'},
				component:'khgl/khgl/ghsz/index'
			},
			{
				meta:{title:'公海池'},
				component:'khgl/khgl/ghc/index'
			},
			{
				meta:{title:'数据看板'},
				component:'khgl/khgl/sjkb/index'
			},
			{
				meta:{title:'销售线索'},
				component:'khgl/khgl/xsxs/index'
			},
			{
				meta:{title:'拜访记录'},
				component:'khgl/khgl/bfjl/index'
			},
			{
				meta:{title:'商机记录'},
				component:'khgl/khgl/sjjl/index'
			},
			{
				meta:{title:'计费配置'},
				component:'khgl/khgl/jfpz/index'
			},
			{
				meta:{title:'客户类别管理'},
				component:'khgl/khgl/khlb/index'
			},
			{
				meta:{title:'开票信息'},
				component:'khgl/fpgl/kpxx/index'
			},
			{
				meta:{title:'开票记录'},
				component:'khgl/fpgl/kpjl/index'
			},
			{
				meta:{title:'货物管理'},
				component:'zlgl/cpzl/cpgl/index'
			},
			{
				meta:{title:'产品分类'},
				component:'zlgl/cpzl/cpfl/index'
			},
			{
				meta:{title:'计量单位'},
				component:'zlgl/cpzl/jldw/index'
			},
			{
				meta:{title:'产品品牌'},
				component:'zlgl/cpzl/cppp/index'
			},
			{
				meta:{title:'产品标签'},
				component:'zlgl/cpzl/cpbq/index'
			},
			{
				meta:{title:'规格管理'},
				component:'zlgl/cpzl/gggl/index'
			},
			{
				meta:{title:'产品条码'},
				component:'zlgl/cpzl/cptm/index'
			},
			{
				meta:{title:'价格管理'},
				component:'zlgl/cpzl/jggl/index'
			},
			{
				meta:{title:'客户类型'},
				component:'zlgl/jczl/khlx/index'
			},
			{
				meta:{title:'分类费类型'},
				component:'zlgl/jczl/flflx/index'
			},
			{
				meta:{title:'计费单位'},
				component:'zlgl/jczl/jfdw/index'
			},
			{
				meta:{title:'计费标准'},
				component:'zlgl/jczl/jfbz/index'
			},
			{
				meta:{title:'理货类型'},
				component:'zlgl/qtzl/lhlx/index'
			},
			{
				meta:{title:'货物包装'},
				component:'zlgl/jczl/hwbz/index'
			},
			{
				meta:{title:'货物类型'},
				component:'zlgl/jczl/hwlx/index'
			},
			{
				meta:{title:'储存方式'},
				component:'zlgl/jczl/ccfs/index'
			},
			{
				meta:{title:'货运线路'},
				component:'zlgl/jczl/hyxl/index'
			},
			{
				meta:{title:'提货类型'},
				component:'zlgl/jczl/thlx/index'
			},
			{
				meta:{title:'货运站点'},
				component:'zlgl/jczl/hyzd/index'
			},
			{
				meta:{title:'仓库资料'},
				component:'zlgl/qtzl/ckzl/index'
			},
			{
				meta:{title:'物流公司'},
				component:'zlgl/qtzl/wlgs/index'
			},
			{
				meta:{title:'项目资料'},
				component:'zlgl/qtzl/xmzl/index'
			},
			{
				meta:{title:'客户资料'},
				component:'khgl/khgl/khxx/khzl'
			},
			{
				meta:{title:'客户关联账号'},
				component:'khgl/khgl/glzh/index'
			},
			{
				meta:{title:'计费配置'},
				component:'khgl/khgl/khxx/jfpz',
				
			},
			{
				meta:{title:'添加客户'},
				component:'khgl/khgl/khxx/create'
			},
			{
				meta:{title:'查看客户'},
				component:'khgl/khgl/khxx/ck'
			},
			{
				meta:{title:'转移客户'},
				component:'khgl/khgl/khxx/zykh'
			},
			{
				meta:{title:'开票信息'},
				component:'khgl/khgl/khxx/kpxx'
			},
			
			
			
			
			{
				meta:{title:'编辑货物'},
				component:'zlgl/cpzl/cpgl/create'
			},
			{
				meta:{title:'编辑入仓订单'},
				component:'rcgl/ddcl/rcdd/create'
			},
			{
				meta:{title:'编辑返存订单'},
				component:'rcgl/ddcl/xfcdd/create'
			},
			{
				meta:{title:'编辑加货订单'},
				component:'rcgl/ddcl/jhdd/create'
			},
			{
				meta:{title:'编辑货物上板'},
				component:'rcgl/ddcl/hwsb/create'
			},
			{
				meta:{title:'编辑货物转库'},
				component:'rcgl/ddcl/hwzk/create'
			},
			{
				meta:{title:'编辑入仓装卸单'},
				component:'rcgl/ddcl/rczxd/create'
			},
			{
				meta:{title:'出仓下单'},
				component:'ccgl/ddcl/ccdd/create'
			},
			{
				meta:{title:'出仓申请下单'},
				component:'ccgl/ddcl/ccdd/ccsqxd'
			},
			{
				meta:{title:'发车单'},
				component:'ccgl/ddcl/fcdd/index'
			},
			{
				meta:{title:'发车单下单'},
				component:'ccgl/ddcl/fcdd/create'
			},
			{
				meta:{title:'班车设置'},
				component:'ccgl/ddcl/fcdd/bcsz'
			},
			{
				meta:{title:'班车面板'},
				component:'ccgl/ddcl/fcdd/bcmb'
			},
			{
				meta:{title:'财务计费'},
				component:'cwgl/cwxx/cwjf/index'
			},
			{
				meta:{title:'财务计费单编辑'},
				component:'cwgl/cwxx/cwjf/create'
			},
			{
				meta:{title:'BOM设置'},
				component:'zlgl/cpzl/cpgl/bom'
			},
			{
				meta:{title:'调拨下单'},
				component:'ckgl/ckcl/dbd/create'
			},
			{
				meta:{title:'盘点下单'},
				component:'ckgl/ckcl/pdd/create'
			},
			{
				meta:{title:'组装下单'},
				component:'ckgl/ckcl/zzd/create'
			},
			{
				meta:{title:'拆卸下单'},
				component:'ckgl/ckcl/cxd/create'
			},
			{
				meta:{title:'损耗下单'},
				component:'ckgl/ckcl/shd/create'
			},
			{
				meta:{title:'录入库存'},
				component:'ckgl/ckxx/qckc/create'
			},
			{
				meta:{title:'添加生产订单'},
				component:'djgl/scrw/scxd/create'
			},
			{
				meta:{title:'生产领料下单'},
				component:'djgl/scrw/scll/create'
			},
			{
				meta:{title:'生产退料下单'},
				component:'djgl/scrw/sctl/create'
			},
			{
				meta:{title:'成品入库下单'},
				component:'djgl/zjhrk/cprk/create'
			},
			{
				meta:{title:'绩效统计'},
				component:'djgl/scrw/scdd/grjx'
			},
			{
				meta:{title:'制作MRP单'},
				component:'djgl/scrw/mrp/create'
			},
			
			
			
			
			
			
			
			
			// 中间表
			{
				meta:{title:'添加部门'},
				component:'zjb/bmjg/index'
			},
			{
				meta:{title:'部署流程'},
				component:'zjb/bslc/index'
			},
			{
				meta:{title:'执行流程'},
				component:'zjb/zxlc/index'
			},
			{
				meta:{title:'客户资料'},
				component:'zjb/khzl/index'
			},
			{
				meta:{title:'查看关联'},
				component:'zjb/ckgl/index'
			},
			{
				meta:{title:'添加销售出库'},
				component:'zjb/tjxsck/index'
			},
			{
				meta:{title:'添加采购入库'},
				component:'zjb/tjcgrk/index'
			},
			{
				meta:{title:'添加生产订单'},
				component:'zjb/tjscdd/index'
			},
			{
				meta:{title:'打印报表'},
				component:'zjb/dybb/index'
			},
			{
				meta:{title:'打印'},
				component:'zjb/dybb/dy'
			},
			{
				meta:{title:'制定MRP'},
				component:'zjb/zdmrp/index'
			},
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			{
				meta:{title:'商品列表'},
				component:'shop/goods/list'
			},
			{
				meta:{title:'创建商品'},
				component:'shop/goods/create'
			},
			{
				meta:{title:'修改商品详情'},
				component:'shop/goods/content'
			},
			{
				meta:{title:'媒体设置'},
				component:'shop/goods/banner'
			},
			{
				meta:{title:'商品属性'},
				component:'shop/goods/attr'
			},
			{
				meta:{title:'商品规格'},
				component:'shop/goods/sku'
			},
			{
				meta:{title:'相册管理'},
				component:'image/index'
			},
			{
				meta:{title:'分类管理'},
				component:'shop/category/list'
			},
			{
				meta:{title:'商品规格管理'},
				component:'shop/sku/list'
			},
			{
				meta:{title:'商品类型管理'},
				component:'shop/type/list'
			},
			{
				meta:{title:'商品评论管理'},
				component:'shop/comment/list'
			},
			{
				meta:{title:'发票管理'},
				component:'order/invoice/list'
			},
			{
				meta:{title:'售后服务'},
				component:'order/after-sale/list'
			},
			{
				meta:{title:'订单列表'},
				component:'order/order/list'
			},
			{
				meta:{title:'会员列表'},
				component:'user/user-list/list'
			},
			{
				meta:{title:'会员等级'},
				component:'user/user-level/list'
			},
			{
				meta:{title:'基础设置'},
				component:'set/base/index'
			},
			{
				meta:{title:'物流设置'},
				component:'set/express/index'
			},
			
			{
				meta:{title:'交易设置'},
				component:'set/payment/index'
			},
			{
				meta:{title:'公告管理'},
				component:'set/notice/index'
			},
			{
				meta:{title:'优惠券管理'},
				component:'shop/coupon/list'
			},
			{
				meta:{title:'404错误'},
				component:'error/404'
			},
			
		]
	},
	{
		meta: {title: '登录页'},
		component: 'login/index'
	},
	{
		path: '*',
		redirect: {name: 'index'},
	}
]

// 获取路由信息方法
let getRoutes = function() {
	// 生成路由详细信息
	createRoute(routes)
	return routes
}

// 自动生成路由
function createRoute(arr) {
	// 循环自动生成
	for (let i = 0; i < arr.length; i++) {
		if (!arr[i].component) return
		// 如过有index结尾的话，去除index
		let val = getValue(arr[i].component)
		// 生成name
		arr[i].name = arr[i].name || val.replace(/\//g, '_')
		// 生成path
		arr[i].path = arr[i].path || `/${val}`
		// 自动生成component
		let componentFun = import(`../../views/${arr[i].component}.vue`)
		arr[i].component = () => componentFun
		// 如果children子路由里面>0有内容 则再次运行createRoute(arr)
		if (arr[i].children && arr[i].children.length > 0) {
			createRoute(arr[i].children)
		}
	}
}

// 去除index结尾方法
function getValue(str) {
	// str = login/index
	// 获取最后一个/的索引
	let index = str.lastIndexOf('/')
	// 获取最后一个/后面的值
	let val = str.substring(index + 1, str.length)
	// 判断是不是index结尾
	if (val === 'index') {
		return str.substring(index, -1)
	}
	return str
}

export default getRoutes()
